import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  @Input() loaderHeight: 'small' | 'medium' | 'default' = 'default'
  loader:any
  imageUrl = environment.whitelabelLogoPath
  constructor() { }
  ngOnInit(): void {
    let data  =JSON.parse(localStorage.getItem('whitelabelResData')) ;
    if(!data) {
      this.loader = "/assets/gif/loader.gif"
    } else {
      this.loader = `${this.imageUrl}/${data?.gifLoader}`
    }
  }

}
